<template>
  <div class="min-h-screen flex overflow-hidden">
    <div
      class="absolute md:hidden flex justify-between items-center mt-16 -top-8 -left-5"
    >
      <router-link :to="{ name: 'Login' }">
        <icon name="logo-neopass" class="text-indigo-600 transform scale-75" />
      </router-link>
      <help-button @helpClick="showHelp = true" :absolute="false" />
    </div>

    <help :show-help="showHelp" @close="showHelp = false" />

    <div class="hidden md:block w-1/4 bg-white h-screen lg:w-1/3">
      <router-link
        :to="{ name: 'Login' }"
        class="flex items-center justify-center mt-16 lg:justify-start lg:ml-10 xl:ml-12 xxl:ml-16"
      >
        <icon name="logo-neopass" class="text-indigo-600 md:h-10 lg:h-auto" />
      </router-link>
      <div class="flex items-center justify-center h-1/2 lg:h-full">
        <illustration name="Inscription" class="w-9/12" />
      </div>
    </div>
    <div
      class="bg-gray-200 rounded-tl-2xl flex-1 flex flex-col w-3/4 px-4 py-40 sm:px-6 md:py-16 md:flex-none md:px-10 lg:w-2/3 lg:justify-center xxl:pl-24"
    >
      <div class="hidden md:block">
        <help-button @helpClick="showHelp = true" />
      </div>

      <div class="mx-auto w-full max-w-2xl xl:ml-10">
        <h1 class="text-4xl text-left font-normal leading-8 text-gray-900">
          Création de compte
        </h1>
        <div v-if="!userType || userType === undefined || userType === ''">
          <p class="mt-4 text-base font-normal text-gray-600">
            Vous êtes un particulier, ou vous faites partie d'une structure.
          </p>
          <p class="text-base font-normal text-gray-600">
            Séléctionnez le type de compte que vous souhaitez créer.
          </p>

          <div class="mt-12 grid grid-cols-1 gap-16 sm:gap-5 sm:grid-cols-2">
            <div
              class="relative group bg-indigo-200 overflow-visible cursor-pointer hover:shadow rounded-sm h-40 w-74 border-2 border-transparent hover:border-indigo-600"
              :class="{ 'border-indigo-600': form.type === 'structure' }"
              @click="form.type = 'structure'"
            >
              <div class="flex justify-between items-center px-4 py-5 sm:p-6">
                <p
                  class="text-3xl leading-5 font-normal text-gray-900 group-hover:text-indigo-600"
                  :class="{ 'text-indigo-600': form.type === 'structure' }"
                >
                  Structure
                </p>

                <Icon
                  name="checkmark"
                  class="h-7 w-7 text-indigo-200 rounded-full p-1.5"
                  :class="{ 'bg-indigo-600': form.type === 'structure' }"
                />
              </div>
              <illustration
                name="Entreprise"
                class="absolute right-4 top-18 w-48"
              />
            </div>
            <div
              class="relative group bg-pink-100 overflow-visible cursor-pointer hover:shadow rounded-sm h-40 w-74 border-2 border-transparent hover:border-pink-600"
              :class="{ 'border-pink-600': form.type === 'particulier' }"
              @click="form.type = 'particulier'"
            >
              <div class="flex justify-between items-center px-4 py-5 sm:p-6">
                <p
                  class="text-3xl leading-5 font-normal text-gray-900 group-hover:text-pink-600"
                  :class="{ 'text-pink-600': form.type === 'particulier' }"
                >
                  Particulier
                </p>
                <icon
                  name="checkmark"
                  class="h-7 w-7 text-pink-100 rounded-full p-1.5"
                  :class="{ 'bg-pink-600': form.type === 'particulier' }"
                />
              </div>
              <illustration
                name="Particulier"
                class="absolute right-4 top-16 w-48"
              />
            </div>
          </div>
        </div>

        <form
          v-if="form.type"
          action="#"
          @submit.prevent="register"
          autocomplete="off"
        >
          <div class="mt-24 grid grid-cols-6 gap-6 items-center">
            <div class="col-span-6 sm:col-span-3">
              <input-text
                id="firstname"
                class="mt-1"
                name="firstname"
                libelle=""
                :value="form.firstname"
                @input="
                  (newValue) => {
                    form.firstname = newValue;
                  }
                "
                :big="true"
                placeholder="Prénom"
              />
            </div>

            <div class="col-span-6 sm:col-span-3">
              <input-text
                id="lastname"
                class="mt-1"
                name="lastname"
                libelle=""
                :value="form.lastname"
                @input="
                  (newValue) => {
                    form.lastname = newValue;
                  }
                "
                :big="true"
                placeholder="Nom"
              />
            </div>

            <div
              v-if="form.type === 'structure'"
              class="col-span-6 sm:col-span-3"
            >
              <input-text
                id="company"
                class="mt-1"
                name="company"
                libelle=""
                :value="form.company"
                @input="
                  (newValue) => {
                    form.company = newValue;
                  }
                "
                :big="true"
                placeholder="Nom de la structure"
              />
            </div>

            <div
              v-if="form.type === 'structure'"
              class="col-span-6 sm:col-span-3"
            >
              <input-text
                id="function"
                class="mt-1"
                name="function"
                libelle=""
                :value="form.function"
                @input="
                  (newValue) => {
                    form.function = newValue;
                  }
                "
                :big="true"
                placeholder="Fonction"
              />
            </div>

            <div
              v-if="form.type === 'structure'"
              class="col-span-6 sm:col-span-3 relative"
            >
              <input-select
                class="md:col-span-3"
                name="typeStructure"
                libelle=""
                :value="form.typeStructure"
                @input="
                  (newValue) => {
                    form.typeStructure = newValue;
                  }
                "
                :datas="[
                  {
                    value: constants.TYPE_ESAT,
                    libelle: 'Secteur adapté et protégé',
                  },
                  {
                    value: constants.TYPE_OF,
                    libelle: 'Organisme de Formation',
                  },
                  { value: constants.TYPE_ESSMS, libelle: 'ESSMS' },
                  { value: constants.TYPE_ENTREPRISE, libelle: 'Entreprise' },
                  { value: constants.TYPE_ASSOCIATION, libelle: 'Association' },
                  {
                    value: constants.TYPE_PUBLIC,
                    libelle: 'Établissement public',
                  },
                  { value: constants.TYPE_AUTRE, libelle: 'Autre' },
                ]"
                :big="true"
                placeholder="Type de structure"
                :is-tooltip-libelle="true"
              />
            </div>

            <div class="sm:col-span-3 sm:col-start-1 col-start-1 col-span-full">
              <input-text
                id="email"
                type="email"
                class="mt-1"
                name="email"
                libelle=""
                :value="form.email"
                @input="
                  (newValue) => {
                    form.email = newValue;
                  }
                "
                :error="true"
                :big="true"
                placeholder="Adresse Email"
                :required="true"
              />
            </div>
            <div class="sm:col-span-3 col-span-full">
              <input-text
                id="email-confirm"
                type="email"
                class="mt-1"
                name="email-confirm"
                libelle=""
                :value="emailConfirmation"
                @input="
                  (newValue) => {
                    emailConfirmation = newValue;
                    errors.errors.email = '';
                  }
                "
                :big="true"
                placeholder="Confirmer l'Adresse Email"
                :required="true"
                :error="!emailIsConfirmed && emailConfirmation != ''"
                msg-error="Les adresses email ne correspondent pas"
              />
            </div>

            <div class="relative col-start-1 col-span-6 sm:col-span-3">
              <input
                id="password"
                :type="passwordFieldType"
                v-model="form.password"
                placeholder="Mot de passe"
                required
                class="bg-white border border-indigo-600 border-opacity-50 rounded-md placeholder-gray-600 block w-full sm:text-base py-5 px-5 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 appearance-none transition duration-150 ease-in-out sm:leading-5"
              />
              <div
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                @click="switchVisibility(1)"
              >
                <icon
                  name="eye"
                  v-if="passwordFieldType === 'password'"
                  class="h-5 w-5 text-pink-600"
                />
                <icon v-else name="eye-off" class="h-5 w-5 text-pink-600" />
              </div>
            </div>

            <div class="relative col-span-6 sm:col-span-3">
              <input
                id="password_confirmation"
                :type="passwordFieldType2"
                v-model="form.password_confirmation"
                placeholder="Confirmation du mot de passe"
                required
                class="bg-white border border-indigo-600 border-opacity-50 rounded-md placeholder-gray-600 block w-full sm:text-base py-5 px-5 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 appearance-none transition duration-150 ease-in-out sm:leading-5"
              />
              <div
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                @click="switchVisibility(2)"
              >
                <icon
                  name="eye"
                  v-if="passwordFieldType2 === 'password'"
                  class="h-5 w-5 text-pink-600"
                />
                <icon v-else name="eye-off" class="h-5 w-5 text-pink-600" />
              </div>
            </div>

            <!-- display errors -->
            <v-errors
              :errors="{ ...errors }"
              class="text-xs font-medium text-pink-600 col-span-full"
            />

            <div class="col-span-6 flex justify-center">
              <big-action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="INSCRIPTION"
                :spinner="loading"
                :right="true"
                icon="arrow-right_1"
                type-shadow="shadow-pink"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from './../../constants';
import InputText from '../../components/Inputs/InputText';
import InputSelect from '../../components/Inputs/InputSelect';
import HelpButton from '../../components/HelpButton';
import Help from './popup/Help';
import BigActionButton from './../../components/BigActionButton';
import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Register',

  components: {
    InputText,
    InputSelect,
    HelpButton,
    Help,
    BigActionButton,
    Illustration,
    Icon,
  },

  data() {
    return {
      constants: Constants,
      form: {
        type: '',
        firstname: '',
        lastname: '',
        company: '',
        function: '',
        email: '',
        password: '',
        password_confirmation: '',
        typeStructure: '',
        affiliateCode: '',
      },
      emailConfirmation: '',
      passwordFieldType: 'password',
      passwordFieldType2: 'password',
      loading: false,
      errors: null,
      showHelp: false,
    };
  },

  mounted() {
    if (this.userType && this.userType != undefined && this.userType != '') {
      if (!['particulier', 'structure'].includes(this.userType)) {
        window.location.replace('/register');
      }
      this.form.type = ['particulier', 'structure'].includes(this.userType)
        ? this.userType
        : 'particulier';
    }

    this.form.affiliateCode = this.affiliateCode;
  },

  methods: {
    ...mapActions({
      RegisterAction: 'auth/register',
    }),

    async register() {
      if (!this.emailIsConfirmed) {
        this.errors = {
          errors: {
            email: 'Les adresses email ne correspondent pas',
          },
        };
        return;
      }
      this.loading = true;
      this.errors = null;
      try {
        await this.RegisterAction(this.form);
        this.$router.replace({ name: 'Dashboard' });
      } catch (error) {
        if (error.response.data.errors) {
          this.errors = { ...error.response.data.errors };
        } else {
          this.errors = { errors: { msg: error.message } };
        }
      }
      this.loading = false;
    },

    switchVisibility(input) {
      if (input == 1) {
        this.passwordFieldType =
          this.passwordFieldType === 'password' ? 'text' : 'password';
      }
      if (input == 2) {
        this.passwordFieldType2 =
          this.passwordFieldType2 === 'password' ? 'text' : 'password';
      }
    },
  },

  computed: {
    ...mapGetters({
      affiliateCode: 'app/affiliateCode',
    }),

    userType() {
      return this.$route.params.type;
    },

    emailIsConfirmed() {
      return this.form.email === this.emailConfirmation;
    },
  },
};
</script>

<style>
select:invalid {
  color: #919aa6;
}
</style>
